import  * as React from 'react';

class Header extends React.Component {
    state ={
        show: false,
    };
    render() {
        return (
            <header>
                <div className="container">
                    <div className="items flex align-center justify-between">
                        <div className="logo">
                            <a href="#" className="logo-text sm">strada</a>
                        </div>
                        <ul className={"nav-items " + (this.state.show && 'show' || '')}>
                            <li><a href="#">how it works</a></li>
                            <li><a href="#">features</a></li>
                            <li><a href="#">contact</a></li>
                            <li className="outline ml-3"><a href="#">SIGN IN</a></li>
                        </ul>
                        <button className="btn-simple hamburger-icon" onClick={() => this.setState({show:!this.state.show})}><i className="icon-hamburger">{''}</i></button>
                    </div>
                </div>
            </header>
        )
    }
}

export default Header;


// WEBPACK FOOTER //
// ./src/components/Homepage/Header.tsx